import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2594cbd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading-title float-start" }, "Dependents", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "verbiage-header" }, " Please add the dependents you want to enroll in benefit(s) or update any existing dependents’ information. ")
], -1))
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "mt-3 container" }
const _hoisted_8 = { class: "float-start rowbox-size" }
const _hoisted_9 = { class: "dependent-img" }
const _hoisted_10 = { class: "dependent-name" }
const _hoisted_11 = { class: "relation-type" }
const _hoisted_12 = { class: "float-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))
const _hoisted_16 = { class: "my-table-row" }
const _hoisted_17 = { class: "the-col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Date Of Birth", -1))
const _hoisted_19 = { class: "the-value the-number" }
const _hoisted_20 = { class: "the-col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "SSN", -1))
const _hoisted_22 = { class: "the-value the-number" }
const _hoisted_23 = { class: "the-col" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Gender", -1))
const _hoisted_25 = { class: "the-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_DependentModal = _resolveComponent("DependentModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "btn btn-primary add-btn float-end",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
        }, " ADD DEPENDENT "),
        _hoisted_3
      ]),
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        (_ctx.validationMsg)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "alert alert-danger",
              innerHTML: _ctx.validationMsg
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dependentAlldata, (allData) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "w-100 dependent-layout mt-3",
            key: allData.electionDependentId
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(allData.firstName) + " " + _toDisplayString(allData.lastName), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(allData.relationshipName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  class: "edit-pencil modalopen modify-value btn-link",
                  role: "button",
                  onClick: ($event: any) => (_ctx.openModifyModal(allData))
                }, "Modify", 8, _hoisted_13),
                _createElementVNode("a", {
                  class: "modalopen delete-icon btn-link",
                  role: "button",
                  onClick: ($event: any) => (_ctx.openDeleteModal(allData))
                }, "Delete", 8, _hoisted_14)
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDate(allData.dob)), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString(allData.ssn), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(allData.genderName), 1)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.saveBtnTxt,
      onSubmitHandler: _ctx.submitHandler,
      onBackButtonHanlder: _ctx.backButtonHanlder
    }, null, 8, ["save-btn-txt", "onSubmitHandler", "onBackButtonHanlder"]),
    _createVNode(_component_DependentModal, {
      visible: _ctx.showModal,
      action: _ctx.action,
      onClose: _ctx.closeModal,
      electionDependentId: _ctx.selectedElectionDependentId,
      electionId: _ctx.selectedElectionId,
      benefits: _ctx.dependentBenefits,
      onGetDependents: _ctx.getAllData
    }, null, 8, ["visible", "action", "onClose", "electionDependentId", "electionId", "benefits", "onGetDependents"]),
    _createVNode(_component_DeleteModal, {
      visible: _ctx.showDeleteModal,
      onClose: _ctx.closeDleteModal,
      onGetDependents: _ctx.getAllData,
      electionDependentId: _ctx.selectedElectionDependentId
    }, null, 8, ["visible", "onClose", "onGetDependents", "electionDependentId"])
  ], 64))
}